/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
// libraries

import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';

// Components com SSR habilitado (SEO/importância estrutural)
import HeadComponent from '../components/head/head';
import WelcomePieces from '../components/pieces/welcome/WelcomePieces';
import WelcomePieces2 from '../components/pieces/welcome2/WelcomePieces2';

// Dynamic Imports para otimizar client-side
const Topo = dynamic(() => import('../components/pieces/topo/Topo'), { ssr: true });
const PopUpComponent = dynamic(() => import('../components/popUp/PopUpComponent'), { ssr: false });
const OwnersPieces = dynamic(() => import('../components/pieces/owners/OwnersPieces'), { ssr: false });
const BusinessPieces = dynamic(() => import('../components/pieces/business/BusinessPieces'), { ssr: true });
const ApartamentCard = dynamic(() => import('../components/carousel/apartment/ApartamentCard'), { ssr: false });
const ApartamentCard1 = dynamic(() => import('../components/carousel/apartment/ApartamentCard1'), { ssr: false });
const WhatsAppComponent = dynamic(() => import('../components/fixed/whatsapp/WhatsappComponent'), { ssr: false });
const FavoritosComponent = dynamic(() => import('../components/fixed/favoritos/FavoritosComponent'), { ssr: false });
const Popup = dynamic(() => import('../components/pieces/popup/popup'), { ssr: false });
const Simulador = dynamic(() => import('../components/pieces/simulador/simulador'), { ssr: false });
const DepoimentoCard = dynamic(() => import('../components/carousel/depoimentos/DepoimentosCard'), { ssr: false });
const ManagerCard = dynamic(() => import('../components/carousel/manager/ManagerCard'), { ssr: false });
const NoticePieces = dynamic(() => import('../components/pieces/notice/NoticePieces'), { ssr: false });
const NoveltyPieces = dynamic(() => import('../components/pieces/novelty/NoveltyPieces'), { ssr: false });
const Novidades = dynamic(() => import('../components/pieces/novidades/Novidades'), { ssr: false });
const SelectionCarousel = dynamic(() => import('../components/carousel/selection/SelectionCarousel'), { ssr: false });
const SkeletonApartamentCard= dynamic(() => import('../components/cards/apartament/SkeletonApartamentCard'), { ssr: false });
const SocialNetworks= dynamic(() => import('../components/pieces/socialNetworks/SocialNetworks'), { ssr: false });
const BlogCarousel= dynamic(() => import('../components/carousel/blog/BlogCarousel'), { ssr: false });

// About - já estava como dynamic (ok!)
const AboutPieces = dynamic(() => import('../components/pieces/about/AboutPieces'), { ssr: true });
const AboutPieces1 = dynamic(() => import('../components/pieces/about1/AboutPieces1'), { ssr: true });

// Serviços
import { motion } from 'framer-motion';
import DepoimentoCard2 from '../components/carousel/depoimentos/DepoimentosCard2';
import { useAuth } from '../components/context/Info';
import { carrossel_select, imoveis_novidades, properties_carrossel, propertiesTop10 } from '../services/properties';
import { getCompany } from '../services/selectors';
import styles from '../styles/Home.module.css';
import { formatSelects, formatSelectsTransacao } from '../utils/FunctionsGlobals';
import { getWithTTL, setWithTTL } from '../utils/storage';

// MAIN COMPONENT


const Home = () => {
    const router = useRouter();
    const { simulador } = router.query;
    const {
        allDataHome,
        favorito,
        setFavorito,
        allViewProperties,
        isMobile1,
        init_props,
        politic,
        setAllCompany,
        allCompany,
        listCategory,
        listCaracteristicas,
        allCarrosseis,
        setAllCarrosseis
    } = useAuth();

    // useState
    const valores = {precos_venda: [allDataHome?.precos_venda[0] || null], precos_locacao: [allDataHome?.precos_locacao[0] || null]};
    const site = allDataHome?.site;
    const [open, setOpen] = useState(false);
    const allOwners = allDataHome?.banner_empresa;
    const [allPropertiesCarrossel1, setAllPropertiesCarrossel1] = useState([]);
    const [allPropertiesCarrossel2, setAllPropertiesCarrossel2] = useState([]);
    const allCards = init_props?.allCards || [];
    const codsite2 = init_props?.codsite;
    const { codsite } = router.query;
    const allManagers = allDataHome?.parceiros?.filter(
        (v: any) => v.url_foto?.length
    ) || [];
    const allDepoimentos = allDataHome?.depoimentos?.filter(
        (v: any) => v.depoimento?.length
    ) || [];
    const dataHome = allDataHome;
    const origin = init_props?.prodOrigin;
    const bannerHome = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "home");
    const bannerPopup = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "popup");
    const bannerFundo = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "fundo");
    const redes_sociais = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "redes_sociais");
    const bannerTopo = allDataHome?.allBanners.filter((item: { ativo: Boolean; }) => item.ativo === true);
    const bannerPersona = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "persona_home");
    const persona_redes = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "persona_redes");
    const fundo_blog = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "blog");
    const urlBannerHome = bannerHome ? bannerHome.length > 0 ? bannerHome : null : null;
    const urlBannerPopup = bannerPopup ? bannerPopup.length > 0 ? bannerPopup : null : null;
    const urlBannerFundo = bannerFundo ? bannerFundo.length > 0 ? bannerFundo[0] : null : null;
    const urlBlogFundo = fundo_blog ? fundo_blog.length > 0 ? fundo_blog[0] : "" : "";
    const urlBannerTopo = bannerTopo ? bannerTopo.length > 0 ? bannerTopo[0] : null : null;
    const urlBannerPersona = bannerPersona ? bannerPersona.length > 0 ? bannerPersona[0] : null : null;
    const urlBannePersonaRedes = persona_redes ? persona_redes.length > 0 ? persona_redes[0] : null : null;
    const urlBannerRedesSociais = redes_sociais ? redes_sociais.length > 0 ? redes_sociais[0] : null : null;
    const [companyInputActual, setCompanyInputActual] = useState('');
    const [fullScreen, setFullScreen] = useState(0);
    const [fullScreenPopup, setFullScreenPopup] = useState(0);
    const [activeDrawer, setActiveDrawer] = useState<any>(null);
    const allTypes = allDataHome?.tipos ? formatSelects(allDataHome?.tipos) : [];
    const allCities = allDataHome?.cidades ? formatSelects(allDataHome?.cidades,allDataHome?.site?.cidade_priorizada) : [];
    const allTransacao = allDataHome?.site?.transacoes ? formatSelectsTransacao(allDataHome?.site?.transacoes) : []
    const total_carrosseis = allDataHome?.carrosseis?.length || 0;
 
    useEffect(() => {
        GetInfoSite();
        if(allCarrosseis?.length == 0 && total_carrosseis > 0){
            GetCachesCarr();
        }
        GetCachePropertiesWeb();
        if(simulador == "1"){
            setFullScreen(1);
        }
    }, []);

    useEffect(() => {
        if (site && politic === 'accepted') {
            GetMetaTags();
        }
    }, [site, politic]);

    const GetMetaTags = () => {
        if (site?.link_chat_head) {
            // Script get google analytics
            const [listGtag] = site.link_chat_head.match(/GTM-(.*?)'/g) || [];
            const gtag = listGtag?.replace("'", '');

            // Google Tag Manager
            if(gtag){
                const tagManagerArgs = {
                    gtmId: gtag,
                };
                TagManager.initialize(tagManagerArgs);
            } else {
                if (site?.tag_google_head) {
                    // Script get google tag
                    const listGoogleTag = site.tag_google_head.match(/dataLayer','(.*?);/g) || [];
                    const googleTag = (listGoogleTag[0] || '')?.split("dataLayer','");
                    const gtmId = (googleTag[1] || '')?.replace("');", '');
                    // Google Tag Manager
                    const tagManagerArgs = {
                        gtmId,
                    };
                    if(gtmId){
                        TagManager.initialize(tagManagerArgs);
                    }
                }
            }
        } else {
            if (site?.tag_google_head) {
                // Script get google tag
                const listGoogleTag = site.tag_google_head.match(/dataLayer','(.*?);/g) || [];
                const googleTag = (listGoogleTag[0] || '')?.split("dataLayer','");
                const gtmId = (googleTag[1] || '')?.replace("');", '');
                // Google Tag Manager
                const tagManagerArgs = {
                    gtmId,
                };
                if(gtmId){
                    TagManager.initialize(tagManagerArgs);
                }
            }
        }
    };

    useEffect(() => {
        if (allCompany?.length == 0 && site?.exibir_empreendimento) {
            const timeOutId = setTimeout(() => {
                const getCondo: any = JSON.parse(localStorage.getItem('condominios') || '[]');
                { getCondo?.empreendimentos?.length > 0 ?
                    (setAllCompany(formatSelects(getCondo)))
                : companyInputActual ? GetAllCompany() : null}
            }, 1000);
            return () => clearTimeout(timeOutId);
        }
    }, [companyInputActual]);

    const getCities = async () => {
        if(site?.id == 2059 || site?.titulo_c_1 != "DESTAQUES DE VENDAS" || site?.titulo_c_2 != "DESTAQUES DE LOCAÇÃO"){
            const GetPropertiesApartament1 = await carrossel_select(1,"", origin, codsite2);
            if(GetPropertiesApartament1?.carrossel_select){
                setAllPropertiesCarrossel1(GetPropertiesApartament1?.carrossel_select);
                localStorage.setItem('carrossel_11', JSON.stringify(GetPropertiesApartament1?.carrossel_select));
            }
            
            const GetPropertiesApartament2 = await carrossel_select(2,"", origin, codsite2);
            if(GetPropertiesApartament2?.carrossel_select){
                setAllPropertiesCarrossel2(GetPropertiesApartament2?.carrossel_select);
                localStorage.setItem('carrossel_22', JSON.stringify(GetPropertiesApartament2?.carrossel_select));
            }
        }
    };

    const GetInfoSite = async () => {
        getCities();
        GetBannerNovidades();
        window.localStorage.removeItem('condominios');
    };

    const GetAllCompany = async () => {
        if(allCompany?.length == 0 && site?.exibir_empreendimento ) {
            const infoCompany = await getCompany('',origin, codsite2);
            setAllCompany(formatSelects(infoCompany?.empreendimentos));
            localStorage.setItem('condominios', JSON.stringify(infoCompany));
        }
    };

    const GetCachesCarr = async () => {
        const getAllCarrosseis = getWithTTL<any>(`all_carrosseis:${allDataHome?.carrosseis?.length}`);

        if(getAllCarrosseis){
            setAllCarrosseis(getAllCarrosseis)
        } else {
            let all_carrosseis = []
            const key_carrossel = `all_carrosseis${allDataHome?.carrosseis?.length}`

            const all_carrosseis_cache = getWithTTL<any>(key_carrossel);
            
            if(all_carrosseis_cache){
                all_carrosseis = all_carrosseis_cache;
            } else {
                if(allDataHome){
                    for (const element of allDataHome.carrosseis) {
                        if (element.personalizado) {
                            let cacheKey = `all_carrosseis_${element.id}`;
                            const imoveisCarrosseis = getWithTTL<any>(cacheKey);

                            if (imoveisCarrosseis) {
                                const arrays = imoveisCarrosseis
                                all_carrosseis.push(arrays); // Converte string para objeto
                            } else {
                                const resultado = await properties_carrossel( 
                                    element,
                                    '',
                                    init_props?.prodOrigin,
                                    codsite2
                                );

                                if(resultado?.imoveis?.imoveis?.length > 3){
                                    const arrays = [element,resultado?.imoveis?.imoveis]

                                    all_carrosseis.push(arrays);

                                    setWithTTL(cacheKey, JSON.stringify(resultado?.imoveis?.imoveis), 900);
                                }
                            }
                        } else {
                            if(element.novidades_semana){
                                const cacheKey = `imoveis_novidade`;

                                const imoveisNovidades = getWithTTL<any>(cacheKey);

                                if (imoveisNovidades) {
                                    const arrays = imoveisNovidades
                                    all_carrosseis.push(arrays); // Converte string para objeto
                                } else {
                                    const resultado = await imoveis_novidades("",init_props?.prodOrigin, codsite2, '');

                                    if(resultado?.imoveis_novidades?.length > 3){
                                        const arrays = [element,resultado?.imoveis_novidades]

                                        all_carrosseis.push(arrays);

                                        setWithTTL(cacheKey, JSON.stringify(resultado?.imoveis_novidades), 900);
                                    }
                                }
                            } else {
                                if(element.top_10){
                                    const cacheKey = `properties_top10${element?.id}`;

                                    const imoveisTop10 = getWithTTL<any>(cacheKey);

                                    if (imoveisTop10) {
                                        const arrays = imoveisTop10
                                        all_carrosseis.push(arrays); // Converte string para objeto
                                    } else {
                                        const resultado = await propertiesTop10('',init_props?.prodOrigin, codsite2, '')

                                        if(resultado?.imoveis_destaque?.length > 3){
                                            const arrays = [element,resultado?.imoveis_destaque]

                                            all_carrosseis.push(arrays);

                                            setWithTTL(cacheKey, JSON.stringify(resultado?.imoveis_destaque), 900);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if(all_carrosseis?.length > 0){
                    setAllCarrosseis(all_carrosseis)
                    setWithTTL(`all_carrosseis:${allDataHome?.carrosseis?.length}`, JSON.stringify(all_carrosseis), 900);
                }
            }
        }
    };

    const GetCachePropertiesWeb = () => {
        try {
            if((site?.id == 2059 || site?.titulo_c_1 != "DESTAQUES DE VENDAS" || site?.titulo_c_2 != "DESTAQUES DE LOCAÇÃO") && !allPropertiesCarrossel1){
                const getPropertiesApartament: any = localStorage.getItem('carrossel_11');
                if(getPropertiesApartament?.length > 0)
                    setAllPropertiesCarrossel1(JSON.parse(getPropertiesApartament || '') || []);
            }
            if((site?.id == 2059 || site?.titulo_c_1 != "DESTAQUES DE VENDAS" || site?.titulo_c_2 != "DESTAQUES DE LOCAÇÃO") && !allPropertiesCarrossel2){
                const getPropertiesApartament: any =
                    localStorage.getItem('carrossel_22');
                if(getPropertiesApartament?.length > 0)
                    setAllPropertiesCarrossel2(JSON.parse(getPropertiesApartament || '') || []);
            }
        } catch (error) {}
    };

    const GetBannerNovidades = async () => {
        const variavelSalva = sessionStorage.getItem('bannerPopup');
        if (variavelSalva != "true" && urlBannerPopup) {
            sessionStorage.setItem('bannerPopup', 'true');
            setFullScreenPopup(1);
        } else {
            setFullScreenPopup(0);
        }
    };

    return (
        <div className={styles.container} style={{backgroundColor: site?.cor5}}>
            {!site ? null : <HeadComponent site={site} banner={urlBannerTopo?.url}/>}
            {site?.id != 2049 && <WhatsAppComponent site={site} codsite={codsite2} origin={origin} open={open} setOpen={setOpen}/>}
            {favorito?.length > 0 ?
                <FavoritosComponent site={site} favorito={favorito} compartilhar={false} codsite={codsite2}/>
            : null }
            {site?.modelo_topo == 2 ?
                <Topo site={site} setActiveDrawer={setActiveDrawer}/>
            : 
                <Topo site={site} setActiveDrawer={setActiveDrawer}/>
            }
            {site?.modelo_busca == 2 ?
                <WelcomePieces2
                    allCities={allCities}
                    allTypes={allTypes}
                    allTransacao={allTransacao}
                    allCompany={allCompany}
                    site={site}
                    personaSrc={urlBannerPersona ? urlBannerPersona?.url : ""}
                    urlBanner={urlBannerTopo ? urlBannerTopo?.url : ""}
                    companyInputActual={companyInputActual}
                    setCompanyInputActual={setCompanyInputActual}
                    setActiveDrawer={setActiveDrawer}
                    activeDrawer={activeDrawer}
                    favorito={favorito}
                    origin={origin}
                    codsite={codsite2}
                    valores={valores}
                    codsite2={codsite}
                    isMobile1={isMobile1}
                    props={allDataHome}
                />
            :
            <WelcomePieces
                allCities={allCities}
                allTypes={allTypes}
                allTransacao={allTransacao}
                allCompany={allCompany}
                site={site}
                urlBanner={urlBannerTopo ? urlBannerTopo?.url : ""}
                companyInputActual={companyInputActual}
                setCompanyInputActual={setCompanyInputActual}
                setActiveDrawer={setActiveDrawer}
                activeDrawer={activeDrawer}
                favorito={favorito}
                origin={origin}
                codsite={codsite2}
                valores={valores}
                codsite2={codsite}
                isMobile1={isMobile1}
                props={allDataHome}
                allCards={allCards}
            />}

            {site?.modelo_selection == 2 &&
            <SelectionCarousel site={site} allCaract={listCaracteristicas} codsite={codsite}/>}

            {urlBannerHome && urlBannerHome.length > 0 && site?.id != 2052 && site?.id != 2291 ?
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    viewport={{ once: true, amount: 0.22 }}
                >
                    <NoveltyPieces banner={urlBannerHome} site={site}/>
                </motion.div>
            : null}

            {((urlBannerPopup && urlBannerPopup.length > 0) || site?.id == 2238) && fullScreenPopup ?
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    viewport={{ once: true, amount: 0.22 }}
                >
                    <Popup banner={urlBannerPopup} setFullScram={setFullScreenPopup} site={site}/>
                </motion.div>
            : null}

            {allCarrosseis?.length > 0 ?
                allCarrosseis.map((carrossel: any, idx: number) => (
                    site?.modelo_card == 2 ?
                        <ApartamentCard1
                            key={idx}
                            slides={carrossel[1]}
                            url={site?.transacoes ? `/imoveis/${site.transacoes[0].toLowerCase()}/-/-/-/-?ordem=desc-inclusao` : ""}
                            title={carrossel[0]?.titulo ? carrossel[0]?.titulo : `CARROSSEL ${allCarrosseis?.length}`}
                            site={site}
                            favorito={favorito || []}
                            setFavorito={setFavorito}
                            codsite={codsite}
                            is_mobile={isMobile1}
                            cores={carrossel[0]}
                            allViewProperties={allViewProperties}
                        />
                    : 
                        <ApartamentCard
                            key={idx}
                            slides={carrossel[1]}
                            url={site?.transacoes ? `/imoveis/${site.transacoes[0].toLowerCase()}/-/-/-/-?ordem=desc-inclusao` : ""}
                            title={carrossel[0]?.titulo ? carrossel[0]?.titulo : `CARROSSEL ${allCarrosseis?.length}`}
                            site={site}
                            favorito={favorito || []}
                            setFavorito={setFavorito}
                            codsite={codsite}
                            is_mobile={isMobile1}
                            allViewProperties={allViewProperties}
                        />
                ))
            : total_carrosseis > 0 &&
                allDataHome?.carrosseis.map((e, id) => (
                    <motion.div
                        key={id}
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <SkeletonApartamentCard carrossel={e}/>
                    </motion.div>
                ))
            }

            {(site?.id == 2146 || site?.id == 2320 || site?.id == 2059 || site?.titulo_c_1 != "DESTAQUES DE VENDAS" || site?.titulo_c_2 != "DESTAQUES DE LOCAÇÃO") && allPropertiesCarrossel1?.length > 2 ? (
                site?.modelo_card == 2 ?
                    <ApartamentCard1
                        slides={allPropertiesCarrossel1}
                        url={site?.transacoes && site?.id != 2059 ? "/imoveis/"+site?.transacoes[0].toLowerCase()+"/-/-/-/Garden" : ""}
                        title={site?.id === 2320 ? "SÍTIO" : site?.titulo_c_1 ? site?.titulo_c_1 : "APARTAMENTOS GARDEN"}
                        site={site}
                        favorito={favorito || []}
                        setFavorito={setFavorito}
                        codsite={codsite}
                        is_mobile={isMobile1}
                        allViewProperties={allViewProperties}
                    />
                : 
                    <ApartamentCard
                        slides={allPropertiesCarrossel1}
                        url={site?.transacoes && site?.id != 2059 ? "/imoveis/"+site?.transacoes[0].toLowerCase()+"/-/-/-/Garden" : ""}
                        title={site?.id === 2320 ? "SÍTIO" : site?.titulo_c_1 ? site?.titulo_c_1 : "APARTAMENTOS GARDEN"}
                        site={site}
                        favorito={favorito || []}
                        setFavorito={setFavorito}
                        codsite={codsite}
                        is_mobile={isMobile1}
                        allViewProperties={allViewProperties}
                    />
            ) : null}

            {(site?.id == 2146 || site?.id == 2320 || site?.id == 2059 || site?.titulo_c_1 != "DESTAQUES DE VENDAS" || site?.titulo_c_2 != "DESTAQUES DE LOCAÇÃO") && allPropertiesCarrossel2?.length > 2 ? (
                site?.modelo_card == 2 ?
                    <ApartamentCard1
                        slides={allPropertiesCarrossel1}
                        url={site?.transacoes && site?.id != 2059 ? "/imoveis/"+site?.transacoes[0].toLowerCase()+"/-/-/-/Garden" : ""}
                        title={site?.id === 2320 ? "SÍTIO" : site?.titulo_c_1 ? site?.titulo_c_1 : "APARTAMENTOS GARDEN"}
                        site={site}
                        favorito={favorito || []}
                        setFavorito={setFavorito}
                        codsite={codsite}
                        is_mobile={isMobile1}
                        allViewProperties={allViewProperties}
                    />
                : 
                <ApartamentCard
                    slides={allPropertiesCarrossel2}
                    url={site?.transacoes && site?.id != 2059 ? "/imoveis/"+site?.transacoes[0].toLowerCase()+"/-/-/-/Studio" : ""}
                    title={site?.id === 2320 ? "CHÁCARA" : site?.titulo_c_2 ? site?.titulo_c_2 : "STUDIOS E 1 DORMITÓRIO"}
                    site={site}
                    favorito={favorito || []}
                    setFavorito={setFavorito}
                    codsite={codsite}
                    allViewProperties={allViewProperties}
                    is_mobile={isMobile1}
                />
            ) : null}

            {(urlBannerRedesSociais && urlBannePersonaRedes && site?.exibe_redes_sociais && (allDataHome?.redes_sociais?.length) || site?.id == 2301) &&
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    viewport={{ once: true, amount: 0.22 }}
                >
                    <SocialNetworks props={init_props} urlBannerRedesSociais={urlBannerRedesSociais?.url} urlBannePersonaRedes={urlBannePersonaRedes?.url}></SocialNetworks>
                </motion.div>
            }

            {allOwners?.paragrafo_3 == "2" && site?.banner_home == "1" ?
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    viewport={{ once: true, amount: 0.22 }}
                >
                    <BusinessPieces
                        site={site}
                        allOwners={allOwners}
                    />
                </motion.div>
            : site?.banner_home == "1" && !isMobile1 && (allOwners?.paragrafo_1 || allOwners?.subtitulo_1 || allOwners?.linkbanner) ? (
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    viewport={{ once: true, amount: 0.22 }}
                >
                    <OwnersPieces
                        allOwners={allOwners}
                        site={site}
                        setFullScram={setFullScreen}
                    />
                </motion.div> 
                ) : null
            }

            {Number(site?.carrossel_corretores) && allManagers.length && site?.id != 1968 ? (
                <div id="equipe">
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <ManagerCard
                            slides={allManagers}
                            title={site?.id == 2098 || site?.id == 2146 ? "ATENDIMENTO EXCLUSIVO" : site?.id == 1959 || site?.id == 2091 ? "FALE CONOSCO" : site?.id == 2122 ? "COMPRA, VENDA E LOCAÇÃO DE IMÓVEIS" : "NOSSA EQUIPE"}
                            site={site}
                        />
                    </motion.div>
                </div>
            ) : null}
            {allDepoimentos.length ? 
            site?.modelo_depoimento == 2 ?
                (<motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    ><DepoimentoCard2
                        slides={allDepoimentos}
                        title="DEPOIMENTOS"
                        site={site}
                    /></motion.div>) 
                :
                (
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <DepoimentoCard
                            slides={allDepoimentos}
                            title="DEPOIMENTOS"
                            site={site}
                        />
                    </motion.div>
                ) 
            : null}
            {(!isMobile1 || site?.id == 2091) && (site?.widget_instagram || dataHome?.videos) && politic === 'accepted' ? (
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    viewport={{ once: true, amount: 0.22 }}
                >
                    <NoticePieces site={site} title={site?.id == 1609 ? "FIQUE POR DENTRO": `NOSSO INSTAGRAM ${site?.id == 1559 ? " NH" : ""}`} videos={dataHome?.videos}/>
                </motion.div>
            ) : null}
            {urlBannerHome && urlBannerHome.length > 0 && site?.id == 2291 ?
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    viewport={{ once: true, amount: 0.22 }}
                >
                    <NoveltyPieces banner={urlBannerHome} site={site}/>
                </motion.div>
            : null}
            {site?.modelo_card != 2 && site?.id != 1873 && site?.id != 1789 && (!isMobile1 || site?.id == 2091) && site?.id != 1925 && site?.id != 2016 && site?.id != 1937 && site?.id != 1968 ? 
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    viewport={{ once: true, amount: 0.22 }}
                >
                    <Novidades isMobile={isMobile1} site={site} setFullScram={setFullScreen} bannerWelcome={urlBannerFundo}/>
                </motion.div>
            : null}
            {fullScreen && site?.simulador && site?.simulador != undefined ?
                <Simulador site={site} setFullScram={setFullScreen} flutua={1} origin={origin}/>
            : null}
            {urlBannerHome && urlBannerHome.length > 0 && site?.id == 2052 ?
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    viewport={{ once: true, amount: 0.22 }}
                >
                    <NoveltyPieces banner={urlBannerHome} site={site}/>
                </motion.div>
            : null}
            {allDataHome?.blogs?.length && site?.modelo_blogs == 2 &&
                <BlogCarousel site={site} posts={allDataHome?.blogs} bannerUrl={urlBlogFundo}/>
            }
            { site?.rodape == 1 ?
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    viewport={{ once: true, amount: 0.22 }}
                >
                    <AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>
                </motion.div>
            :
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    viewport={{ once: true, amount: 0.22 }}
                >
                    <AboutPieces site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1}/>
                </motion.div>
            }

            {site ?
                <PopUpComponent site={site}/>
            : null}
        </div>
    );
};

export default Home;
